<template>
  <div class="w-full mt-4 panel">
    <div class="flex flex-row w-full text-blue font-bold">{{ $t('report_sections') }}</div>
    <p class="text-gray-400 text-sm mb-2">{{ $t('report_sections_help') }}</p>
    <b-field>
      <div v-for="(tab, index) in localSections" :key="'switch_detailed_report_section'+index">
        <b-switch v-if="tab.visible"
          :disabled="tab.disabled"
          v-model="tab.print"
          type="is-primary"
          size="is-small"
          @input="() => { $emit('epc-select-sections', localSections) }"
        >
          {{ tab.name }}
        </b-switch>
      </div>
    </b-field>
  </div>
</template>

<script>

export default {
  name: "select-sections-detailed-report-panel",

  props: {
    sections: {
      type: Array,
      required: true
    },
  },

  data() {
    return {
      isLoading: false,
      localSections: JSON.parse(JSON.stringify(this.sections))
    };
  },

  methods: {

  }
}
</script>